<template>
  <div class="product-card-prices">
    <span v-if="!product.availableForSale" class="product-card-prices__sold">Sold Out</span>

    <template v-else-if="hasBasePriceRange">
      <div class="product-card-prices__main">
        <span class="product-card-prices__from">From</span>
        <ShopifyPrice :amount="basePriceMin" />
        <span class="product-card-prices__dash">—</span>
        <ShopifyPrice :amount="basePriceMax" />
      </div>

      <div v-if="showChainSuffix" class="product-card-prices__suffix">(+ Chain)</div>
      <div v-if="isDsmExclusive" class="product-card-prices__dsm">*(DSM Exclusive)</div>
    </template>

    <template v-else>
      <div class="product-card-prices__main">
        <ShopifyPrice class="product-card-prices__price" :amount="basePriceMin" />
      </div>

      <div v-if="showChainSuffix" class="product-card-prices__suffix">(+ Chain)</div>
      <div v-if="isDsmExclusive" class="product-card-prices__dsm">*(DSM Exclusive)</div>
    </template>

    <ShopifyPrice class="product-card-prices__compare" v-if="priceCompare" :amount="priceCompare" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useProductInject } from '../../../context/useProductContext'
import ShopifyPrice from '../../shopify/ShopifyPrice.vue'

const { product, priceCompare } = useProductInject()

const basePriceMin = computed<number>(() => Number(product.priceRange?.minVariantPrice?.amount ?? 0))
const basePriceMax = computed<number>(() => Number(product.priceRange?.maxVariantPrice?.amount ?? 0))

const hasBasePriceRange = computed(() => basePriceMax.value > basePriceMin.value)

const showChainSuffix = computed(() => Boolean(product.chainEnabled?.value))

const isDsmExclusive = computed(() => {
  const tags = Array.isArray((product as any).tags) ? (product as any).tags : []
  return tags.some((tag) => String(tag).toLowerCase() === 'dsm-hide')
})
</script>

<style lang="scss">
@import '~styles/base';

.product-card-prices {
  display: flex;
  flex-direction: column;
  vertical-align: baseline;
  transition: var(--transition-opacity);
  gap: 0px !important;

  &__main {
    display: flex;
    align-items: baseline;
  }

  @media (min-width: 1001px) {
    &__main {
      justify-content: flex-end !important;
    }
  }

  &__from {
    margin-right: 4px;
  }

  &__dash {
    margin: 0 4px;
  }

  &__dsm {
    white-space: nowrap;
  }

  &__compare {
    margin-left: 5px;
    text-decoration: line-through;
  }

  @media (min-width: 1001px) {
    text-align: right !important;
  }

  @include breakpoint('xl') {
    margin-top: 10px;
  }
}
</style>
